import './App.css';
// import Home from './Pages/Home/Home'
// import Agro from './Pages/Agro/Agro'
import Router from '../src/router'


function App() {
  return (
    <div className="App">
      {/* <Home/> */}
      {/* <Agro/> */}
      <Router/>
      
    </div>
  );
}

export default App;
